import AmortCode from "@/domain/maintenance/AmortCode";
import editable from "@/domain/decorators/editable";

export default class ProdAmortItem extends editable {
    public amortItemID!: number;
    public amortCode!: number;
    public prodAmortItemLineNumber!: number;
    public prodAmortItemDescription!: string;
    public prodAmortItemCostQty1!: number;
    public prodAmortItemCostQty2!: number;
    public prodAmortItemCostQty3!: number;
    public prodAmortItemCostQty4!: number;
    public prodAmortItemCostQty5!: number;
    public eachQty1!: number;
    public eachQty2!: number;
    public eachQty3!: number;
    public eachQty4!: number;
    public eachQty5!: number;
    public productBomID!: number;
    public productBomLineNumber!: number; // From productBom
    public prodAmortItemQuantity!: number;
    public prodAmortItemComments!: string;
    public prodAmortItemOverridePrice!: string;

    //Amort_Codes table
    public amortCodeObj!: AmortCode; // Deprecated. We already have  amortCode, this object is not used to make any DB changes, and we aren't using this object for anything on the front-end

    constructor(init?: Partial<ProdAmortItem>) {
        super();
        Object.assign(this, init);
    }

    public compareTo(val: ProdAmortItem): number {
        return this.productBomLineNumber > val.productBomLineNumber ? 1 :
            this.productBomLineNumber === val.productBomLineNumber ? 0 :
                -1;
    }
}
